/* Moved from snippets/cart-drawer.liquid so browsers cache it (speed audit, 15 Oct 2026). */
/* HLTH cart drawer — runtime safety patches + UI behaviour.
   The shipped Dawn cart.js has a few issues that surface here:
     (1) updateQuantity's trailing trapFocus call references `.drawer__inner-empty`
         and `.cart-item__name`. When those aren't found in our custom markup,
         trapFocus(null, ...) -> getFocusableElements(null) throws, the fetch
         .then rejects into .catch, and the user sees the generic error text.
     (2) The error box is never cleared on a successful update, so stale error
         text lingers across valid operations.
   Fix: make trapFocus / getFocusableElements null-safe, and clear errors before
   each updateQuantity call.

   Also: trust ribbon rotation; Subscribe & Save and how-often buttons on the lines. */
(function () {
  function patchFocusHelpers() {
    if (typeof window.getFocusableElements === 'function' && !window.getFocusableElements.__hlthWrapped) {
      var origGetFocusable = window.getFocusableElements;
      window.getFocusableElements = function (container) {
        if (!container) return [];
        try { return origGetFocusable(container); } catch (_) { return []; }
      };
      window.getFocusableElements.__hlthWrapped = true;
    }
    if (typeof window.trapFocus === 'function' && !window.trapFocus.__hlthWrapped) {
      var origTrapFocus = window.trapFocus;
      window.trapFocus = function (container, elementToFocus) {
        if (!container) return;
        try { return origTrapFocus(container, elementToFocus); } catch (_) { /* swallow */ }
      };
      window.trapFocus.__hlthWrapped = true;
    }
  }

  function patchCartItems() {
    var Klass = window.customElements && customElements.get('cart-drawer-items');
    if (!Klass || Klass.__hlthPatched) return;
    Klass.__hlthPatched = true;
    var original = Klass.prototype.updateQuantity;
    Klass.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      var errBox = document.getElementById('CartDrawer-CartErrors');
      if (errBox) errBox.textContent = '';
      var lineErr = document.getElementById('CartDrawer-LineItemError-' + line);
      var lineErrText = lineErr && lineErr.querySelector('.cart-item__error-text');
      if (lineErrText) lineErrText.textContent = '';
      var input = document.getElementById('Drawer-quantity-' + line);
      if (input && input.hasAttribute('data-hlth-group')) {
        return updateGroupedRow(this, line, quantity, input);
      }
      return original.call(this, line, quantity, event, name, variantId);
    };
  }

  /* ---- One row per product, flavour and plan ----
     The Liquid draws lines Shopify split for a buy-X-get-Y code as one row, at the first line,
     with the other lines' keys and quantities on its input. A change to that row (stepper,
     typed number or the bin) is spread across those lines in one /cart/update.js call:
     the first line takes the difference, and only below the others' total do they shrink.
     Then the drawer is redrawn (refreshCartSections). */
  function updateGroupedRow(items, line, quantity, input) {
    var others = null;
    try { others = JSON.parse(input.getAttribute('data-hlth-group')); } catch (_) {}
    var key = input.getAttribute('data-hlth-key');
    if (!others || !others.length || !key) return Promise.resolve();
    var target = Math.max(0, parseInt(quantity, 10) || 0);
    var offset = others.reduce(function (sum, o) { return sum + o.qty; }, 0);
    var updates = {};
    if (target >= offset) {
      updates[key] = target - offset;
    } else {
      updates[key] = 0;
      var left = target;
      others.forEach(function (o) {
        var q = Math.min(o.qty, left);
        updates[o.key] = q;
        left -= q;
      });
    }
    if (typeof items.enableLoading === 'function') items.enableLoading(line);
    var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        return refreshCartSections().then(function () {
          var empty = !cart || cart.item_count === 0;
          var cd = document.querySelector('cart-drawer');
          if (cd) cd.classList.toggle('is-empty', empty);
          var di = document.querySelector('cart-drawer-items');
          if (di) di.classList.toggle('is-empty', empty);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
          }
        });
      })
      .catch(function () {
        var errBox = document.getElementById('CartDrawer-CartErrors');
        if (errBox && window.cartStrings) errBox.textContent = window.cartStrings.error;
      })
      .finally(function () {
        if (typeof items.disableLoading === 'function') items.disableLoading(line);
      });
  }

  function patchCartDrawer() {
    // After Add-to-Cart, CartDrawer.renderContents re-renders the panel but the
    // `is-empty` class on the <cart-drawer> root stays from the initial page render.
    // Two-layer fix:
    //   A) subscribe to cartUpdate events and sync is-empty from the real cart
    //      state (fastest path, fires immediately after ATC).
    //   B) patch renderContents so the sync happens even if subscribe fails.
    var CD = window.customElements && customElements.get('cart-drawer');
    if (!CD || CD.__hlthPatched) return;
    CD.__hlthPatched = true;

    function syncEmpty(isEmpty) {
      var cd = document.querySelector('cart-drawer');
      if (cd) cd.classList.toggle('is-empty', !!isEmpty);
      var items = document.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', !!isEmpty);
    }

    try {
      var sub = (typeof subscribe !== 'undefined') ? subscribe : null;
      var evs = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null;
      if (sub && evs && evs.cartUpdate) {
        sub(evs.cartUpdate, function () {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) { syncEmpty(!c || c.item_count === 0); });
        });
      }
    } catch (_) { /* fall through to (B) */ }

    var original = CD.prototype.renderContents;
    CD.prototype.renderContents = function (parsedState) {
      var result = original.call(this, parsedState);
      var nowEmpty = !!this.querySelector('.hlth-cart__empty');
      syncEmpty(nowEmpty);
      // Re-bind the ribbon after re-render.
      bindRibbon();
      return result;
    };
  }

  /* ---- Trust ribbon rotation ---- */
  function bindRibbon() {
    var ribbons = document.querySelectorAll('[data-ribbon]');
    ribbons.forEach(function (ribbon) {
      if (ribbon.__hlthBound) return;
      ribbon.__hlthBound = true;

      var msgs = Array.prototype.slice.call(ribbon.querySelectorAll('.hlth-cart__ribbon-msg'));
      if (msgs.length <= 1) return;
      var idx = 0;
      function show(i) {
        msgs.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
      }
      function next() { idx = (idx + 1) % msgs.length; show(idx); }
      function prev() { idx = (idx - 1 + msgs.length) % msgs.length; show(idx); }

      var prevBtn = ribbon.querySelector('[data-ribbon-prev]');
      var nextBtn = ribbon.querySelector('[data-ribbon-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartTimer(); });

      var timer = window.setInterval(next, 4500);
      function restartTimer() {
        window.clearInterval(timer);
        timer = window.setInterval(next, 4500);
      }
    });
  }

  /* ---- Subscribe & Save and how often, per line (16 Oct 2026) ----
     The Liquid gives a one-time line of a product listed in Theme settings > Cart drawer a
     Subscribe button (the product's first plan), and every subscription line a how-often button
     whose list holds the product's plans (and One-time, for those listed products). Choosing one
     moves every line of that product to it through /cart/change.js (selling_plan, null for
     one-time), a line at a time because a buy-X-get-Y code can split one row into several lines,
     then redraws the drawer. Product-wide, so both shake flavours keep one delivery and the
     2-bag subscription minimum can't be split into two 1-bag subscriptions. */
  function closePlanMenus(except) {
    document.querySelectorAll('[data-plan-toggle][aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (menu) {
        menu.hidden = true;
        menu.style.left = '';
      }
      var li = btn.closest('.hlth-cart__item');
      if (li) li.classList.remove('is-plan-open');
    });
  }

  function openPlanMenu(btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    closePlanMenus(btn);
    btn.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    var li = btn.closest('.hlth-cart__item');
    if (li) li.classList.add('is-plan-open');
    // Keep the list inside the drawer: shift it left when it would run past the panel's edge.
    var panel = btn.closest('.hlth-cart__panel');
    if (panel) {
      var over = menu.getBoundingClientRect().right - (panel.getBoundingClientRect().right - 16);
      if (over > 0) menu.style.left = (-over) + 'px';
    }
    if (typeof menu.scrollIntoView === 'function') menu.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var current = menu.querySelector('[aria-checked="true"]') || menu.querySelector('[data-plan-move]');
    if (current) current.focus({ preventScroll: true });
  }

  function planOf(line) {
    return line.selling_plan_allocation ? String(line.selling_plan_allocation.selling_plan.id) : '';
  }

  function movePlan(productId, fromPlan, toPlan, line) {
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.enableLoading === 'function') items.enableLoading(line);
    var errText = document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text');
    if (errText) errText.textContent = '';
    var changeUrl = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
    var rounds = 0;
    function next() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // From a plan: every subscription line of the product not yet on the new plan.
          // From one-time (the Subscribe button): every one-time line of the product.
          var todo = (cart.items || []).filter(function (it) {
            if (String(it.product_id) !== String(productId)) return false;
            var on = planOf(it);
            return fromPlan ? on !== '' && on !== String(toPlan || '') : on === '';
          })[0];
          if (!todo || rounds++ >= 6) return cart;
          return fetch(changeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: todo.key, quantity: todo.quantity, selling_plan: toPlan ? Number(toPlan) : null })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('plan change ' + r.status);
              return r.json();
            })
            .then(next);
        });
    }
    return next()
      .then(function (cart) {
        return refreshCartSections().then(function () {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
          }
        });
      })
      .catch(function () {
        var el = document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text');
        if (el && window.cartStrings) el.textContent = window.cartStrings.error;
      })
      .finally(function () {
        var fresh = document.querySelector('cart-drawer-items');
        if (fresh && typeof fresh.disableLoading === 'function') fresh.disableLoading(line);
      });
  }

  function bindPlans() {
    if (document.__hlthPlansBound) return;
    document.__hlthPlansBound = true;
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-plan-toggle]');
      if (toggle) {
        if (toggle.getAttribute('aria-expanded') === 'true') closePlanMenus();
        else openPlanMenu(toggle);
        return;
      }
      var mover = e.target.closest('cart-drawer [data-plan-move]');
      if (mover) {
        var to = mover.getAttribute('data-plan-move');
        var from = mover.getAttribute('data-plan-from');
        closePlanMenus();
        if (to === from || mover.disabled) return;
        mover.disabled = true;
        movePlan(mover.getAttribute('data-product-id'), from, to, mover.getAttribute('data-line'))
          .finally(function () { mover.disabled = false; });
        return;
      }
      if (!e.target.closest('.hlth-cart__plan-menu')) closePlanMenus();
    });
    // Arrows move through an open list; Escape closes it without closing the drawer.
    var escClosedMenu = false;
    document.addEventListener('keydown', function (e) {
      var inMenu = document.activeElement && document.activeElement.closest('.hlth-cart__plan-menu');
      if (inMenu && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        var opts = Array.prototype.slice.call(inMenu.querySelectorAll('[data-plan-move]'));
        var at = opts.indexOf(document.activeElement);
        var to = opts[(at + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
        if (to) {
          e.preventDefault();
          to.focus();
        }
        return;
      }
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-plan-toggle][aria-expanded="true"]');
      if (!open) return;
      escClosedMenu = true;
      e.stopPropagation();
      closePlanMenus();
      open.focus();
    }, true);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && escClosedMenu) {
        escClosedMenu = false;
        e.stopPropagation();
      }
    }, true);
  }

  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var newDrawer = parsed.querySelector('#CartDrawer');
          var currentDrawer = document.getElementById('CartDrawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
        if (data && data['cart-icon-bubble']) {
          var parsedB = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = parsedB.querySelector('#cart-icon-bubble');
          var currentBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }
        bindRibbon();
      })
      .catch(function (_) {});
  }

  function boot() {
    if (!window.customElements) return;
    customElements.whenDefined('cart-drawer-items').then(function () {
      patchFocusHelpers();
      patchCartItems();
      patchCartDrawer();
      bindRibbon();
      bindPlans();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
